import { ChangeDetectionStrategy, Component, effect, input, ViewEncapsulation } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { CellRenderer, Column } from '@miq/catalog';
import { DataCellFormatterPipe } from '../../../shared/pipe/data-cell-formatter.pipe';
@Component({
  selector: 'miq-data-column-renderer, [miqDataColumnRenderer]',
  template: `
    <!-- principal column -->
    {{ data | dataCellFormatter: config }} &nbsp;
    @if (config.unit) {
      <!-- unit -->
      {{ data | dataCellFormatter: config.unit }} &nbsp;
    }
    @if (config.related?.length > 0) {
      <!-- related -->
      @for (relCol of config.related; track relCol) {
        {{ data | dataCellFormatter: relCol }} &nbsp;
      }
    }
    `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataCellFormatterPipe],
})
export class DataColumnRendererComponent<T = DataObject> implements CellRenderer<Column> {
  readonly dataInput = input<T>(undefined, { alias: 'data' });
  data: T;
  readonly configInput = input<Column>(undefined, { alias: 'column' });
  config: Column;
  constructor() {
    effect(() => { const v = this.dataInput(); if (v != null) this.data = v; });
    effect(() => { const v = this.configInput(); if (v != null) this.config = v; });
  }
  render(): void {
    // required by CellRenderer
  }
}
